import { IClubGiftResponse } from "interfaces";
import { baseApi } from "../api";

export const clubFreeGiftAPI = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getFreeGift: builder.query({
			query: () => "/rest/club/freeGift",
			providesTags: () => ["FreeGiftTag"],
			transformResponse: (response: IClubGiftResponse | undefined) => {
				if (
					response?.clubFreeGift &&
					"serverNowDate" in response.clubFreeGift
				) {
					// eslint-disable-next-line @typescript-eslint/no-unused-vars
					const { serverNowDate, ...rest } = response.clubFreeGift;
					return {
						...response,
						clubFreeGift: rest
					};
				}
				return response;
			}
		}),
		unlockFreeGift: builder.mutation({
			query: (arg) => {
				const queryParams = new URLSearchParams();
				for (const key in arg.body) {
					queryParams.append(key, arg.body[key]);
				}
				return {
					url: `/rest/club/freeGift?${queryParams.toString()}`,
					method: "POST"
				};
			}
			//invalidatesTags: () => ["FreeGiftTag"]
		}),
		resetFreeGift: builder.mutation({
			query: (arg) => {
				const queryParams = new URLSearchParams();
				for (const key in arg.body) {
					queryParams.append(key, arg.body[key]);
				}
				return {
					url: `/rest/debug/club/freeGift/reset?${queryParams.toString()}`,
					method: "POST"
				};
			},
			invalidatesTags: () => ["FreeGiftTag"]
		}),
		simulatePurchasesFreeGift: builder.mutation({
			query: (arg) => {
				const queryParams = new URLSearchParams();
				for (const key in arg.body) {
					queryParams.append(key, arg.body[key]);
				}
				return {
					url: `/rest/debug/club/freeGift/simulateMemberClicks?${queryParams.toString()}`,
					method: "POST"
				};
			},
			invalidatesTags: () => ["FreeGiftTag"]
		})
	})
});

export const {
	useGetFreeGiftQuery,
	useUnlockFreeGiftMutation,
	useResetFreeGiftMutation,
	useSimulatePurchasesFreeGiftMutation
} = clubFreeGiftAPI;
